import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TransitionGroup, CSSTransition as ReactCSSTransition } from 'react-transition-group';
import { useRef } from 'react';
export const CSSTransition = ({ nodeRef, ...rest }) => {
    const ref = useRef();
    return _jsx(ReactCSSTransition, { nodeRef: nodeRef || ref, ...rest });
};
export { TransitionGroup };
//# sourceMappingURL=index.js.map